function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Check if  element has scrollable content
 * @param {Node} node
 * @returns {Boolean}
 */
export var hasScrollbars = function hasScrollbars(node) {
  var overflowY = getComputedStyle(node)["overflow-y"],
      overflowX = getComputedStyle(node)["overflow-x"],
      vertical = (overflowY === "scroll" || overflowY === "auto") && Math.abs(node.scrollHeight - node.clientHeight) > 1,
      horizontal = (overflowX === "scroll" || overflowX === "auto") && Math.abs(node.scrollWidth - node.clientWidth) > 1;
  return vertical || horizontal;
};
/**
 * Check if element or one of the parents is scrollable
 * @param {Node} node  DOM Node element
 * @returns {Boolean}
 */

export var isScrollable = function isScrollable(node) {
  if (!node || !(_typeof(node) === "object" && node instanceof Element) || node === document.body) {
    return false;
  }

  if (hasScrollbars(node)) {
    return node;
  }

  return isScrollable(node.parentNode);
};